/**
 * VerifiedBadge - Shows a checkmark for identity-verified users
 * Use next to usernames on profiles, posts, and comments
 */

import React from 'react';
import { BadgeCheck } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';

const VerifiedBadge = ({ 
  size = 'sm', 
  showTooltip = true,
  className = '' 
}) => {
  const sizeClasses = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };

  const badge = (
    <BadgeCheck 
      className={`${sizeClasses[size]} text-blue-500 inline-block ${className}`}
      data-testid="verified-badge"
    />
  );

  if (!showTooltip) return badge;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          {badge}
        </TooltipTrigger>
        <TooltipContent>
          <p className="text-xs">Identity Verified</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default VerifiedBadge;
